import { ButtonClimateChampions } from '../display/ui/ButtonClimateChampions';

export class ButtonExtended extends ButtonClimateChampions {
  prompt() {
    if (!this.prompticon) {
      this.prompticon = this.scene.add
        .image(this.x, this.y, 'game_graphics', 'pointer')
        .setOrigin(0.45, 0.05)
        .setAlpha(0);

      this.prompttimeline = this.scene.tweens.createTimeline();
      this.prompttimeline.add({
        targets: this.prompticon,
        alpha: 1,
        duration: 250,
      });
      this.prompttimeline.add({
        targets: this.prompticon,
        scale: 0.75,
        yoyo: true,
        repeat: 1,
        duration: 200,
        delay: 100,
      });
      this.prompttimeline.add({
        targets: this.prompticon,
        alpha: 0,
        duration: 250,
        delay: 100,
      });
      this.prompttimeline.loop = -1;
      this.prompttimeline.loopDelay = 500;
      this.prompttimeline.play();
    }
  }

  stopPrompt() {
    if (this.prompttimeline) {
      this.prompttimeline.destroy();
      this.prompttimeline = null;
    }
    if (this.prompticon) {
      this.prompticon.destroy();
      this.prompticon = null;
    }
  }

  destroy() {
    if (this.prompticon?.destroy) this.prompticon.destroy();
    this.prompticon = null;
    super.destroy();
  }
}
